import React from 'react';
import PropTypes from 'prop-types';
import { setIn } from 'formik';

import { useStyles } from '~/assets/styles';
import { getAllSearchableContactRoles } from '~/components/communications/ContactUtils';
import ContactTextFieldFormik from '~/components/ContactTextFieldFormik';
import MenuItem from '~/components/core/Atomic/MenuItem';
import useOrganization from '~/components/OrganizationContext';
import TextFieldFormik, { ShowOnlyTextField } from '~/components/TextFieldFormik';

const EmailRecipient = (props) => {
  const { recipientEntry, recipientEntryId, disabled, showOnly, isNotClaimRelated } = props;
  const { classes } = useStyles();
  const { organizationContactRolesDict } = useOrganization();

  function getValuesOnSelectContact(contact, valuesWithContact) {
    if (!contact) {
      return setIn(valuesWithContact, `${recipientEntryId}.email_id`, '');
    }

    // recipientEntry still holds the pre-selection entry inside this synchronous call, so this is
    // the old contact id - reading contact_id off valuesWithContact would always match and the
    // email would never be selected
    if (contact.id === recipientEntry.contact_id) {
      // same contact selected, keep the chosen email
      return valuesWithContact;
    }

    // prefill the first address whatever the count, matching the To field and every phone picker;
    // the adjacent select stays enabled for a multi-email contact so the user can change it
    const emailId = contact.emails?.length ? contact.emails[0].id : '';
    return setIn(valuesWithContact, `${recipientEntryId}.email_id`, emailId);
  }

  return (
    <>
      <div>
        <ContactTextFieldFormik
          id={`${recipientEntryId}.contact`}
          fullWidth
          disabled={disabled}
          fixedSearchResults
          getValuesOnSelectContact={getValuesOnSelectContact}
          acceptedRoles={getAllSearchableContactRoles(organizationContactRolesDict).concat('user')}
          showOnly={showOnly}
          outOfContactsContextSearch={isNotClaimRelated}
        />
      </div>
      <div>
        {recipientEntry.contact &&
          (showOnly ? (
            <ShowOnlyTextField
              classes={classes}
              showOnlyValueComponent={recipientEntry.email}
              label="" // To Prevent empty prop warning
            />
          ) : (
            <TextFieldFormik
              id={`${recipientEntryId}.email_id`}
              disabled={disabled || recipientEntry.contact.emails.length <= 1}
              select
              fullWidth
              showOnly={showOnly}
            >
              {recipientEntry.contact.emails.map((email) => (
                <MenuItem key={email.id} value={email.id}>
                  {email.email}
                </MenuItem>
              ))}
            </TextFieldFormik>
          ))}
      </div>
    </>
  );
};

EmailRecipient.propTypes = {
  recipientEntry: PropTypes.object.isRequired,
  recipientEntryId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  showOnly: PropTypes.bool,
  isNotClaimRelated: PropTypes.bool,
};

export default EmailRecipient;
